import 'css-chunk:src/feature/modifier/ModifierBreadCrumbButton.module.scss';export default {
  "root": "ModifierBreadCrumbButton_root",
  "name": "ModifierBreadCrumbButton_name",
  "message": "ModifierBreadCrumbButton_message",
  "pulse": "ModifierBreadCrumbButton_pulse"
};